export class Time {
  elapsed = 0;
  delta = 0;

  tick(deltaMs: number, capMs: number): void {
    this.delta = Math.min(deltaMs, capMs) / 1000;
    this.elapsed += this.delta;
  }
}
